import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { TextInput } from 'app/components/FormsyHelperComponent'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import {
  Popover,
  Card,
  CardHeader,
  CardActions,
  CardContent,
} from '@material-ui/core'
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state'
import CancelButton from 'app/components/buttons/CancelButton'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import useStyles from './customFieldsStyle'
import { MenuItem, Typography } from '@material-ui/core'
import {
  TEXT,
  PHYSICAL_ADDRESS,
  MAILING_ADDRESS,
  SHIPPING_ADDRESS,
  BILLING_ADDRESS,
  ADDRESSES,
} from './constants'
import { SelectFormsy } from '@fuse'

const CustomPhysicalAddressForm = ({
  newCustomDialogStyle,
  saveAddressData,
}) => {
  const styleClass = useStyles()
  const { formatMessage } = useIntl()

  const [addressInputValue, setAddressInputValue] = useState({
    labelType: ADDRESSES[0],
    label: '',
    fieldType: TEXT,
    subFields: [
      { label: 'Country', content: '', fieldType: 1 },
      { label: 'Street Address', content: '', fieldType: 1 },
      { label: 'Street Address Line 2', content: '', fieldType: 1 },
      { label: 'City', content: '', fieldType: 1 },
      { label: 'Postal Code', content: '', fieldType: 1 },
      { label: 'Province', content: '', fieldType: 1 },
    ],
  })

  const handleAddressValue = () => {
    let method
    if (
      addressInputValue.labelType === 'crm.custom.field.physical.address.name'
    ) {
      method = PHYSICAL_ADDRESS
    } else if (
      addressInputValue.labelType === 'crm.custom.field.mailing.address.name'
    ) {
      method = MAILING_ADDRESS
    } else if (
      addressInputValue.labelType === 'crm.custom.field.shipping.address.name'
    ) {
      method = SHIPPING_ADDRESS
    } else if (
      addressInputValue.labelType === 'crm.custom.field.billing.address.name'
    ) {
      method = BILLING_ADDRESS
    }
    addressInputValue['subFields'][0].name =
      addressInputValue.label + '_Country'
    addressInputValue['subFields'][1].name =
      addressInputValue.label + '_StreetAddress'
    addressInputValue['subFields'][2].name =
      addressInputValue.label + '_StreetAddressLine2'
    addressInputValue['subFields'][3].name = addressInputValue.label + '_City'
    addressInputValue['subFields'][4].name =
      addressInputValue.label + '_PostalCode'
    let newaddressInpoutvalue = JSON.parse(JSON.stringify(addressInputValue))
    saveAddressData(newaddressInpoutvalue, method)
    setAddressInputValue({
      ...newaddressInpoutvalue,
      labelType: ADDRESSES[0],
      label: '',
      fieldType: TEXT,
    })
  }
  return (
    <div>
      <PopupState variant="popover" popupId="demo-popup-popover">
        {(popupState) => (
          <div style={{ position: 'relative' }}>
            <div
              className={newCustomDialogStyle}
              style={{ cursor: 'pointer' }}
              {...bindTrigger(popupState)}
            >
              <AddCircleOutlineIcon color="secondary" />
            </div>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Card className={styleClass.cardStyle}>
                <CardHeader
                  title={formatMessage({
                    id: 'crm.custom.field.add.address.information',
                  })}
                  className={styleClass.cardHeaderStyle}
                />
                <CardContent>
                  <div>
                    <SelectFormsy
                      className="w-full"
                      name={addressInputValue.labelType}
                      label={formatMessage({
                        id: 'crm.custom.field.choose.address.media',
                      })}
                      value={addressInputValue.labelType}
                      variant="standard"
                      onChange={(event) => {
                        setAddressInputValue({
                          ...addressInputValue,
                          labelType: event.target.value,
                        })
                      }}
                    >
                      {ADDRESSES.map((item, index) => (
                        <MenuItem key={index} value={item}>
                          <Typography>{formatMessage({ id: item })}</Typography>
                        </MenuItem>
                      ))}
                    </SelectFormsy>
                    <TextInput
                      margin="dense"
                      containerClassName="MuiFormControl-fullWidth"
                      labelId={formatMessage({
                        id: 'crm.custom.field.input.label.name',
                      })}
                      placeholderId={formatMessage({
                        id: 'crm.custom.field.input.label.name',
                      })}
                      variant="standard"
                      fullWidth
                      name="inputAddress"
                      onChange={(event) =>
                        setAddressInputValue({
                          ...addressInputValue,
                          label: event.target.value,
                        })
                      }
                    />
                  </div>
                </CardContent>
                <CardActions className={styleClass.actionsWrapper}>
                  <CancelButton
                    className={styleClass.actionBtn}
                    onClick={() => {
                      popupState.setOpen(false)
                    }}
                  >
                    {formatMessage({ id: 'action.cancel' })}
                  </CancelButton>
                  <PrimaryButton
                    type="submit"
                    className={styleClass.actionBtn}
                    disabled={!addressInputValue.label.length > 0}
                    onClick={() => {
                      handleAddressValue()
                      popupState.setOpen(false)
                    }}
                  >
                    {formatMessage({ id: 'action.ok' })}
                  </PrimaryButton>
                </CardActions>
              </Card>
            </Popover>
          </div>
        )}
      </PopupState>
    </div>
  )
}

export default CustomPhysicalAddressForm
